import { createCRUDHook } from './createCRUDHook';
import { StaffPointDto } from 'utils/models';
import { TBL_STAFF_POINT_INFRACTION } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<StaffPointDto>({
  entityName: 'StaffPoint',
  endpoint: TBL_STAFF_POINT_INFRACTION,
});

export const StaffPointsContext = Context;
export const useStaffPointManager = useManager;
export const useStaffPoints = useConsumer;
